import { useTransactionsFeesHunterDetailEarnings } from "Api/Queries/Transactions/useTransactionsFeesHunterDetailEarnings";
import { BaseTransactionFeesTab } from "Components/Transactions/UserTransactionFees/BaseTransactionFeesTab";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { getRegionCurrency } from "Utils/CurrencyUtils";
import { endOfMonth, startOfMonth } from "date-fns";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  userID: number;
};

export const HunterDetailTransactionFees = ({ userID }: Props) => {
  const { t } = useResource();
  const dateFrom = startOfMonth(new Date()).toISOString();
  const dateTo = endOfMonth(new Date()).toISOString();
  const currentUser = useLoggedInUser();

  const { data: hunterEarnings, isLoading } =
    useTransactionsFeesHunterDetailEarnings(userID, dateFrom, dateTo);

  return (
    <BaseTransactionFeesTab
      amounts={hunterEarnings?.totalFees ?? []}
      emptyStateCurrency={
        currentUser?.region ? getRegionCurrency(currentUser.region) : undefined
      }
      isLoading={isLoading}
      title={t(Resources.Components.Settlements.TotalEarnings)}
      colorVariant="success"
    />
  );
};
